import { useQuery } from 'react-query';
import { cacheKeys } from 'config';
import { documentsClient } from 'clients/documents/documentsClient';

import { SearchQuestionsParams } from 'clients/documents/documentsClient.types';

type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useQuestionSearch = (params: SearchQuestionsParams, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, status, error } = useQuery(
    [cacheKeys.documents.searchQuestions, params],
    () => documentsClient.searchQuestions(params),
    {
      enabled: options.enabled,
    },
  );

  return {
    status,
    error,
    count: data?.count || 0,
    results: data?.results || [],
  };
};
